import * as moment from 'moment';

export enum DateFormat {
    DEFAULT = 'DD-MM-YYYY',
    DEFAULT_DATE_UI = 'DD MMM YY',
    DEFAULT_DATE_TIME_UI = 'DD MMM YY hh:mm A',
    DEFAULT_DATE_TIME_DISPLAY = 'DD MMM YY hh:mma',
    DEFAULT_DATE_TIME_UI_DISPLAY = 'DD MMM YY, hh:mm a',
    DEFAULT_DATE_TIME = 'DDMMMYYYY hh:mmA',
    DEFAULT_TIME = 'hh:mma',
    DEFAULT_DATE_CSV_BILLING = 'DDMMMYY',
    DEFAULT_DATE_TIME_UI_FILE_DOWNLOAD_PANEL = 'hh:mm A,DD MMM',
}

export function formatDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
    const momentObj = moment.utc(date);

    if (!momentObj.isValid()) {
        return date;
    }

    return momentObj.format(format);
}

export function formatLocalDate(date: string, format: DateFormat = DateFormat.DEFAULT): string {
    const momentObj = moment.utc(date).local();

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.format(format);
}

export function getFormatedDate(): string {
    // This Function will return date like  23July2018 12.45 PM
    const date = new Date();
    const options = {
        hour: 'numeric',
        minute: 'numeric',
        hour12: true
    } as const;
    const time = date.toLocaleString([], options);

    const monthNames = ['January', 'February', 'March',
        'April', 'May', 'June',
        'July', 'August', 'September',
        'October', 'November', 'December'];

    return (date.getDate() + monthNames[date.getMonth()] + date.getFullYear() + ' ' + time)
        .replace(':', '.').replace(/[^ -~]/g, '');
}

export function getFormatedTime(utcDate): string {
    // This function will return Time from Utc Date
    // Input utcDate - "2018-08-01T08:55:00.000Z"
    // Output time - "02:25pm"
    const momentObj = moment.utc(utcDate);

    if (!momentObj.isValid()) {
        return '';
    }

    return momentObj.local().format(DateFormat.DEFAULT_TIME);
}

export function isFutureDate(date: string): boolean {
    if (date) {
        const currentDate = new Date();
        const submittedDate = new Date(date);
        return (submittedDate >= currentDate)
    }
    return true;
}
